import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'intrasense-no-data-ui',
  templateUrl: './no-data-ui.component.html',
  styleUrls: ['./no-data-ui.component.scss']
})
export class NoDataUiComponent implements OnInit {
  @Input('heading') heading!: string;
  @Input('description') description!: string;
  constructor() { }

  ngOnInit(): void {
  }

}
